import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { Area } from '../../core/constants/area';
import { of } from 'rxjs/observable/of';
import { SetWorkflowDetailTaskModel } from './models/SetWorkflowDetailTaskModel';
import { SetWorkflowDetailTaskNoteListModel } from './models/SetWorkflowDetailTaskNoteListModel';
import { SetWorkflowDetailTaskPaymentOverrideModel } from './models/SetWorkflowDetailTaskPaymentOverrideModel';
import { WorkflowDetailTaskResponse } from './models/responses';

@Injectable()
export class WorkflowDetailTaskService {

  constructor(public httpClient: HttpClient) { }

  getWorkflowDetailTask(workflowDetailId: number){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetailTask?workflowDetailId=${workflowDetailId}`;
    return this.httpClient.get<WorkflowDetailTaskResponse[]>(url);
  }
  hasCompletedTasks(workflowDetailId: number){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetailTask/HasCompletedTasks?workflowDetailId=${workflowDetailId}`;
    return this.httpClient.get<boolean>(url);
  }
  getWorkflowDetailTaskIfta(workflowDetailTaskId: number){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetailTask/Ifta/${workflowDetailTaskId}`;
    return this.httpClient.get<any[]>(url);
  }
  getWorkflowDetailTaskNonIfta(workflowDetailId: number){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetailTask/NonIfta?workflowDetailId=${workflowDetailId}`;
    return this.httpClient.get<any[]>(url);
  }
  getWorkflowDetailTaskMtn(workflowDetailTaskId: number){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetailTask/Mtn/${workflowDetailTaskId}`;
    return this.httpClient.get<any[]>(url);
  }
  getWorkflowDetailTaskNoteList(workflowDetailTaskId: number){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetailTask/Note/List/${workflowDetailTaskId}`;
    return this.httpClient.get<any[]>(url);
  }
  setWorkflowDetailTask(model: SetWorkflowDetailTaskModel){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetailTask`;
    return this.httpClient.post<any[]>(url, model);
  }
  setWorkflowDetailTaskNonIfta(model: SetWorkflowDetailTaskModel){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetailTask/NonIfta`;
    return this.httpClient.post<any[]>(url, model);
  }
  setWorkflowDetailTaskNoteList(model: SetWorkflowDetailTaskNoteListModel){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetailTask/NoteList`;
    return this.httpClient.post<any[]>(url, model);
  }
  setWorkflowDetailTaskPaymentOverride(model: SetWorkflowDetailTaskPaymentOverrideModel){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetailTask/PaymentOverride`;
    return this.httpClient.post<any[]>(url, model);
  }
  exportWorkflowDetailTaskReport(workflowDetailTaskId: number){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetailTask/ExportReport`;
    return this.httpClient.post<any[]>(url, workflowDetailTaskId);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/workflow/workflow-detail-task.service.ts